import SaleSubmisson from "./SaleSubmission";

export default SaleSubmisson;
